<script>
  import { createEventDispatcher } from "svelte";
  import RenderTBodyRow from "./RenderTBodyRow.svelte";

  export let dataKey = "id";
  export let data = [];
  export let columns = [];
  export let selectedIds = [];
  export let isAllSelected = false;
  export let config;

  let subTableDataId = false;
  const dispatch = createEventDispatcher();

  function toggleDropdown(row) {
    if (subTableDataId === row[dataKey]) {
      subTableDataId = null;
    } else {
      subTableDataId = row[dataKey];
    }
    dispatch("subTableIdChange", row);
  }

  function handleCheckItem(itemId) {
    if (selectedIds.includes(itemId)) {
      selectedIds = selectedIds.filter((id) => id !== itemId);
    } else {
      selectedIds = [...selectedIds, itemId];
    }
  }

  $: {
    if (isAllSelected) {
      selectedIds = data.map((d) => d[dataKey]);
    } else selectedIds = [];
  }

  $: dispatch("checkedChange", { selectedIds });
</script>

<tbody>
  {#each data as row}
    <RenderTBodyRow
      {row}
      {columns}
      {handleCheckItem}
      {toggleDropdown}
      {subTableDataId}
      {dataKey}
      {selectedIds}
      {config}
      on:actionClick
      on:columnClick
    >
      <span slot="sub_table">
        <slot name="sub_table" />
      </span>
    </RenderTBodyRow>
  {/each}
</tbody>
